import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { Logo } from "@/components/Logo";
import { Loader2 } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.replace("#", "")).get("session_id");
    if (!sessionId) { navigate("/login"); return; }

    (async () => {
      try {
        const { data } = await api.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } });
        if (data.session_token) localStorage.setItem("dd_token", data.session_token);
        setUser(data.user);
        // Validated internal return path only (no open redirect); fall back to dashboard.
        const raw = sessionStorage.getItem("ts_post_auth_next");
        sessionStorage.removeItem("ts_post_auth_next");
        const dest = raw && raw.startsWith("/") && !raw.startsWith("//") && !raw.includes("://") ? raw : "/dashboard";
        window.history.replaceState(null, "", dest);
        navigate(dest, { state: { user: data.user } });
      } catch (e) {
        navigate("/login");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen grid place-items-center bg-[#EEF2F6]">
      <div className="flex flex-col items-center gap-4">
        <Logo />
        <div className="flex items-center gap-2 text-[#475569]">
          <Loader2 className="animate-spin" size={18} /> Signing you in…
        </div>
      </div>
    </div>
  );
}
